import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function removeProtocol(url) {
  return url.replace(/http[s]*:\/\//, "");
}

export default function HandelaarInfo(props) {
  return (
    <Dialog
      open={props.open}
      TransitionComponent={Transition}
      keepMounted
      onClose={props.close}
      maxWidth="md"
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <div style={{ minWidth: "500px" }}>
        <DialogTitle id="alert-dialog-slide-title">
          {props.handelaar?.title}
        </DialogTitle>
        <DialogContent
          style={{
            color: "rgba(0, 0, 0, 0.54)",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div style={{ paddingBottom: 40, maxWidth: 275 }}>
                <p>{props.handelaar?.description}</p>
              </div>
              <div style={{ marginTop: "auto" }}>
                <p>{props.handelaar?.address}</p>
                <p>
                  {props.handelaar?.postal} {props.handelaar?.place}
                </p>
              </div>
            </div>
            <div
              style={{
                paddingLeft: 75,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div style={{ paddingBottom: 40 }}>
                <p>Openingsuren</p>
                <p style={{ maxWidth: 275 }}>
                  {props.handelaar?.hours
                    ? props.handelaar.hours
                    : "geen gekende openingsuren"}
                </p>
              </div>

              <div>
                <p> Contact</p>
                <p>
                  {props.handelaar?.number ? (
                    <a
                      style={{
                        textDecoration: "none",
                        color: "rgb(63, 81, 181)",
                      }}
                      href={"tel:" + props.handelaar.number.toString()}
                    >
                      {props.handelaar.number}
                    </a>
                  ) : (
                    "geen nummer opgegeven"
                  )}
                </p>
                <p>
                  {props.handelaar?.mail ? (
                    <a
                      style={{
                        textDecoration: "none",
                        color: "rgb(63, 81, 181)",
                      }}
                      href={"mailto:" + props.handelaar.mail.toString()}
                    >
                      {props.handelaar.mail}
                    </a>
                  ) : (
                    "geen mail opgegeven"
                  )}
                </p>
                <p>
                  {props.handelaar?.site ? (
                    <a
                      style={{
                        textDecoration: "none",
                        color: "rgb(63, 81, 181)",
                      }}
                      href={"http://" + removeProtocol(props.handelaar.site)}
                    >
                      {removeProtocol(props.handelaar.site)}
                    </a>
                  ) : (
                    "geen site opgegeven"
                  )}
                </p>
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions style={{ display: "flex" }}>
          {props.handelaar?.lat && props.handelaar?.long ? (
            <Button
              style={{ marginLeft: 10, marginRight: "auto" }}
              onClick={() =>
                props.changeZoomLocation(
                  props.handelaar?.lat,
                  props.handelaar?.long,
                  21
                )
              }
              color="primary"
            >
              Toon op kaart
            </Button>
          ) : (
            <div style={{ marginLeft: 10, marginRight: "auto" }}>
              <p>Geen kaart informatie</p>
            </div>
          )}
          <Button onClick={props.close} color="primary">
            Sluiten
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
}
